import EventClassService from 'src/modules/eventClass/eventClassService';
import Errors from 'src/modules/shared/error/errors';
import Message from 'src/view/shared/message';
import { getHistory } from 'src/modules/store';
import { i18n } from 'src/i18n';

const prefix = 'EVENTCLASS_FORM';

const eventClassFormActions = {
  INIT_STARTED: `${prefix}_INIT_STARTED`,
  INIT_SUCCESS: `${prefix}_INIT_SUCCESS`,
  INIT_ERROR: `${prefix}_INIT_ERROR`,

  CREATE_STARTED: `${prefix}_CREATE_STARTED`,
  CREATE_SUCCESS: `${prefix}_CREATE_SUCCESS`,
  CREATE_ERROR: `${prefix}_CREATE_ERROR`,

  UPDATE_STARTED: `${prefix}_UPDATE_STARTED`,
  UPDATE_SUCCESS: `${prefix}_UPDATE_SUCCESS`,
  UPDATE_ERROR: `${prefix}_UPDATE_ERROR`,

  doInit: (id) => async (dispatch) => {
    try {
      dispatch({
        type: eventClassFormActions.INIT_STARTED,
      });

      let record = {};

      const isEdit = Boolean(id);

      if (isEdit) {
        record = await EventClassService.find(id);
      }

      dispatch({
        type: eventClassFormActions.INIT_SUCCESS,
        payload: record,
      });
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: eventClassFormActions.INIT_ERROR,
      });

      getHistory().push('/event-class');
    }
  },

  doCreate: (values) => async (dispatch) => {
    try {
      dispatch({
        type: eventClassFormActions.CREATE_STARTED,
      });

      await EventClassService.create(values);

      dispatch({
        type: eventClassFormActions.CREATE_SUCCESS,
      });

      Message.success(
        i18n('entities.eventClass.create.success'),
      );

      getHistory().push('/event-class');
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: eventClassFormActions.CREATE_ERROR,
      });
    }
  },

  doUpdate: (id, values) => async (dispatch, getState) => {
    try {
      dispatch({
        type: eventClassFormActions.UPDATE_STARTED,
      });

      await EventClassService.update(id, values);

      dispatch({
        type: eventClassFormActions.UPDATE_SUCCESS,
      });

      Message.success(
        i18n('entities.eventClass.update.success'),
      );

      getHistory().push('/event-class');
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: eventClassFormActions.UPDATE_ERROR,
      });
    }
  },
};

export default eventClassFormActions;
